/**
 * @description: This custom hook calls the Zipgate component and updates
 * the zipcode in Redux to update the state once the zipcode is entered.
 */

export const displayZipgate = (hideCloseButton?: boolean) => {
  const Acr = window.Acr || undefined;
  if (Acr && Acr.zipgateComponent) {
    Acr.zipgateComponent.openZipgate(
      () => {},
      {},
      false,
      hideCloseButton
    );
  }
}
